import apiClient from "./apiClient";

// Use centralized API client for consistent error handling
const api = apiClient;

// Upload organization logo
export const uploadOrganizationLogo = async (logoFile) => {
  const formData = new FormData();
  formData.append('logo', logoFile);

  const response = await api.post('/api/organizations/logo/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

// Delete organization logo
export const deleteOrganizationLogo = async () => {
  const response = await api.delete('/api/organizations/logo');
  return response.data;
};

// Get organization logo
export const getOrganizationLogo = async (orgId) => {
  const response = await api.get(`/api/organizations/${orgId}/logo`);
  return response.data;
};

// Validate logo file before upload
export const validateLogoFile = (file) => {
  const maxSize = 5 * 1024 * 1024; // 5MB
  const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];

  if (!file) {
    throw new Error('No file selected');
  }

  if (file.size > maxSize) {
    throw new Error('File size must be less than 5MB');
  }

  if (!allowedTypes.includes(file.type)) {
    throw new Error('File must be JPG, PNG, or WebP format');
  }

  return true;
}; 